import en from 'date-fns/locale/en-CA';
import fr from 'date-fns/locale/fr-CA';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useEffect, useRef } from 'libs/react';
import { React } from 'libs/react';
import './TimeInput.scss';
registerLocale('fr', fr);
registerLocale('en', en);
/**
 * @component TimeInput
 * @since 1.0.0
 * @hidden
 */
export function TimeInput(props) {
    const { lang, ident, value, minTime, maxTime, required, disabled, placeholder } = props;
    const node = useRef(null);
    useEffect(() => {
        if (props.focused && node.current) {
            node.current.setFocus();
        }
    }, [props.focused]);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        if (props.onBlur) {
            props.onBlur();
        }
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        if (props.onFocus) {
            props.onFocus();
        }
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(time) {
        if (props.onChange) {
            props.onChange(time);
        }
    }
    const format = 'HH:mm';
    const selected = (() => {
        if (!value || Array.isArray(value))
            return null;
        // HH:mm or HH:mm:ss — not parseable by Date constructor directly
        const hhmmMatch = value.match(/^(\d{1,2}):(\d{2})/);
        if (hhmmMatch) {
            const d = new Date();
            d.setHours(Number(hhmmMatch[1]), Number(hhmmMatch[2]), 0, 0);
            return d;
        }
        const parsed = Date.parse(value);
        return isNaN(parsed) ? null : new Date(parsed);
    })();
    return (React.createElement(DatePicker, { id: ident, ref: node, locale: lang, selected: selected, required: required, disabled: disabled, placeholderText: placeholder, timeIntervals: 15, dateFormat: format, minTime: minTime, maxTime: maxTime, onBlur: onBlur, onFocus: onFocus, onChange: onChange, onSelect: onChange, showTimeSelect: true, showTimeSelectOnly: true, popperPlacement: "bottom-start", portalId: props.portalId }));
}
